import { Card, CardContent, CardMedia, Tooltip, Typography, useTheme } from '@mui/material';
import { CSSProperties, useState } from 'react';

import { ISimplifiedVisualMaterial } from 'api';
import format from 'localization/format';
import { DEFAULT_IMG_SOURCE } from 'modules/material/MaterialItem';
import { colors } from 'theme/mui/colors';

type Props = {
  visualMaterial?: ISimplifiedVisualMaterial;
  onClickCard?: (id: string) => void;
  selected: boolean;
  displayTooltip?: boolean;
  disabled?: boolean;
  imgStyles?: CSSProperties;
};

const Material = (props: Props) => {
  const { visualMaterial, onClickCard, selected, displayTooltip = false, disabled = false, imgStyles = {} } = props;
  const { updatedDate, id, thumbnailUrl, fileName } = visualMaterial || {};
  const { palette } = useTheme();

  const MAX_RETRY = 2;
  const RETRY_DELAY = 3000;

  const [retryCount, setRetryCount] = useState(0);
  const [imgSrc, setImgSrc] = useState(thumbnailUrl);

  const handleClickCard = () => {
    if (disabled) return;
    onClickCard?.(id ?? '');
  };

  const handleError = () => {
    if (retryCount < MAX_RETRY) {
      setTimeout(() => {
        setRetryCount(prev => prev + 1);
        setImgSrc(thumbnailUrl + `?retry=${Date.now()}`);
      }, RETRY_DELAY);
    } else {
      setImgSrc(DEFAULT_IMG_SOURCE);
    }
  };

  return (
    <Tooltip title={displayTooltip ? fileName : undefined} placement="top">
      <Card
        sx={{
          cursor: 'pointer',
          padding: '0.5rem',
          height: '100%',
          minHeight: 180,
          border: selected && !disabled ? `1.5px solid ${colors.primary.main}` : `1px solid ${palette.divider}`,
          backgroundColor: selected ? palette.action.selected : 'initial',
          justifyContent: 'space-between',
        }}
        onClick={handleClickCard}
      >
        <CardMedia
          onError={handleError}
          src={imgSrc}
          title=""
          component="img"
          sx={{
            width: '100%',
            ...imgStyles,
          }}
        />
        <CardContent sx={{ padding: `0 !important` }}>
          <Typography gutterBottom variant="h5">
            {visualMaterial?.description}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {updatedDate ? format(updatedDate, { date: 'short' }) : <>&nbsp;</>}
          </Typography>
        </CardContent>
      </Card>
    </Tooltip>
  );
};

export default Material;
